import React, {useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import useAntTable from "../../../../utils/useAntTable";
import * as api from "../../../../apis/platforms/admin/hospital";
import {Button, Divider, message, Space, Tag} from "antd";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import withAuth from "../../../../utils/withAuth";
import {useHistory} from "react-router-dom";
import {useRequest} from "ahooks";
import UploadModal from "../../../../components/UploadModal";

const AddButton = withAuth('add', Button)
const ImportButton = withAuth('import', Button)
const ExportButton = withAuth('export', Button)

export default function Hospital() {

    const history = useHistory()
    const {form, search, download, downloading, refresh, tableProps} = useAntTable(api.getHospital, {
        downloadUrl: api.exportHospital
    })
    const [uploadModalVisible, setUploadModalVisible] = useState(false)

    const {run: doImportHospital, loading: doImportHospitalLoading} = useRequest(api.importHospital, {
        manual: true,
        onSuccess: () => {
            setUploadModalVisible(false)
            refresh()
        }
    })

    const {run: switchHospital} = useRequest(api.switchHospital, {
        manual: true,
        onSuccess(res) {
            message.success("操作成功")
            refresh()
        }
    })

    const columns = [
        {
            title: '医院编码',
            dataIndex: 'code'
        },
        {
            title: '医院名称',
            dataIndex: 'name'
        },
        {
            title: '检验科负责人',
            dataIndex: 'clinlabLeader'
        },
        {
            title: '检验科负责人电话',
            dataIndex: 'clinlabLeaderTel'
        },
        {
            title: '检验科年收入',
            dataIndex: 'clinlabAnnualIncome'
        },
        {
            title: '床位数',
            dataIndex: 'beds'
        },
        {
            title: '分管院长',
            dataIndex: 'dean'
        },
        {
            title: '状态',
            dataIndex: 'status',
            render(value: boolean) {
                return value ? <Tag color={"green"}>已启用</Tag> : <Tag color={"red"}>已停用</Tag>
            }
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_: any, record: any) => (
                <span>
                    {!record.fixed && (
                        <>
                            <a onClick={() => {
                                history.push(`/customer/hospital/detail/${record.id}`,)
                            }}>详情</a>
                            <Divider type={"vertical"}/>
                            <a onClick={() => switchHospital(record.id)}>{record.status ? '停用' : '启用'}</a>
                        </>
                    )}
                </span>
            )
        }
    ]

    const extSearchColumns: StandardColumnsType = [
        {
            dataIndex: 'hospital',
            title: '医院名称或编号',
            search: {
                colSpan: 6
            }
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} extSearchColumns={extSearchColumns} search={search}
                           form={form} {...tableProps} toolbar={
                <Space>
                    <AddButton type={'primary'}
                               onClick={() => history.push(`/customer/hospital/detail/`)}>新增</AddButton>

                    <ImportButton type={'primary'} onClick={() => setUploadModalVisible(true)}>导入</ImportButton>
                    <ImportButton type={'primary'} onClick={() => download()} loading={downloading}>导出</ImportButton>
                </Space>
            }/>
            <UploadModal onUpload={doImportHospital}
                         open={uploadModalVisible}
                         title={'导入医院'}
                         template={'/template/医院导入模板.xlsx'}
                         confirmLoading={doImportHospitalLoading}
                         onCancel={() => setUploadModalVisible(false)}/>
        </PageHeaderLayout>
    )
}
